import { render } from "./LoadingSpinner.vue?vue&type=template&id=00a5b72e"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=00a5b72e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__